import callAPiBase from './base';

const filterUsersApi = {
  filterUserByName: ({ username, conversationStatus }: { username: string, conversationStatus: number }) =>
    callAPiBase({
      endpoint: `/api/filter/user/name?username=${username}&conversationStatus=${conversationStatus}`,
      method: 'GET',
      useToken: true,
    }),

  filterUserByTag: ({ tagId, conversationStatus }: { tagId: string, conversationStatus: number }) =>
    callAPiBase({
      endpoint: `/api/filter/user/tag?tagId=${tagId}&conversationStatus=${conversationStatus}`,
      method: 'GET',
      useToken: true,
    }),

  filterUserByMessage: ({ message, conversationStatus }: { message: string, conversationStatus: number }) =>
    callAPiBase({
      endpoint: `/api/filter/user/message?message=${message}&conversationStatus=${conversationStatus}`,
      method: 'GET',
      useToken: true,
    }),

  filterTagByName: ({ tag }: { tag: string }) =>
    callAPiBase({
      endpoint: `/api/filter/tag?tag=${tag}`,
      method: 'GET',
      useToken: true,
    }),
};

export { filterUsersApi };
export default filterUsersApi;
